import React from "react";

export const LazyMicrosoftTeamsCallPlayerBridge = React.lazy(
    () => import(/* webpackChunkName: "MSTeams" */ "./Player")
);
